<template>
    <svg version="1.1" id="tick" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 37 37" style="enable-background:new 0 0 37 37;" xml:space="preserve" class="">
        <path class="pe_circ pe_path" d="M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z" />
        
        <polyline 
            v-if="isTick" 
            class="pe_tick pe_path" 
            points="11.6,20 15.9,24.2 26.4,13.8"
        />
        <g v-else>
            <line class="pe_cross pe_path" x1="12" y1="12" x2="25" y2="25"  />
            <line class="pe_cross pe_path" x1="25" y1="12" x2="12" y2="25"  />
        </g>
    </svg>
</template>

<script>

export default {
    name: 'icon',
    props: ['isTick'],
}
</script>

    
<style scoped>

svg {
    width: 40px;
    height: 40px;
}

.pe_circ {
    opacity: 0;
    stroke-dasharray: 130;
    stroke-dashoffset: 130;
    transition: all 1s;
}

.pe_cross {
    opacity: 0;
    stroke-dasharray: 30;
    stroke-dashoffset: 30;
    transition: all 1s;
}

.pe_tick {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    transition: stroke-dashoffset 1s 0.3s ease-out;
}

svg.pe_drawn .pe_path {
    opacity: 1;
    stroke-dashoffset: 0;
}

svg.pe_drawn .pe_cross.pe_path {
    opacity: 1;
    stroke-dashoffset: 0;
}

path,polyline,line {
    fill:none;
    stroke:#000;
    stroke-width:3;
    stroke-linejoin:round;
    stroke-miterlimit:10;    
}

</style>